import React from "react";
import { CampaignMember } from "./companyTypes";
import { AccountListItem, Engagement, Penetration } from "./accounts";
import { KeyRoles, RoleStatus } from "./enums";
import { RoleMembers } from "./apiTypes";

export type IconProps = {
  width?: string;
  height?: string;
  color?: string;
  secondColor?: string;
  opacity?: string;
  rotate?: string;
  onClick?: () => void;
  style?: React.CSSProperties;
};

export const accountsTabs: { [key: string]: string } = {
  rate: "penetration_score",
  score: "total_engagement_score",
};

export type DropdownNestedItem = {
  name: string;
  nestedItems: Array<{ name: string; isAdded: boolean; parent: string }>;
  selected?: boolean;
  isAdded: boolean;
};

export const mockAccountsList: AccountListItem[] = [
  {
    id: "1",
    index: 1,
    company: "--",
    industry: "--",
    region: "--",
    status: "--",
    progress: 0,
    penetration_score: 0,
    total_engagement_score: 0,
    employees_min: 0,
    employees_max: 0,
    size: "--",
    is_new: true,
    total_user_data: 0,
    total_enriched_data: 0,
    scraping_status: "--",
    scraping_update_status: "--",
    can_be_analyzed: false,
    discovery: {
      score: 0,
      your_data: null,
      external_data: null,
    },

    engagement: {
      score: 0,
    },
  },
  {
    id: "2",
    index: 2,
    company: "--",
    industry: "--",
    region: "--",
    status: "--",
    progress: 0,
    penetration_score: 0,
    total_engagement_score: 0,
    employees_min: 0,
    employees_max: 0,
    size: "--",
    is_new: false,
    total_user_data: 0,
    total_enriched_data: 0,
    scraping_status: "--",
    scraping_update_status: "--",
    can_be_analyzed: false,
    discovery: {
      score: 0,
      your_data: null,
      external_data: null,
    },

    engagement: {
      score: 0,
    },
  },
  {
    id: "3",
    index: 3,
    company: "--",
    industry: "--",
    region: "--",
    status: "--",
    progress: 0,
    penetration_score: 0,
    total_engagement_score: 0,
    employees_min: 0,
    employees_max: 0,
    size: "--",
    is_new: false,
    total_user_data: 0,
    total_enriched_data: 0,
    scraping_status: "--",
    scraping_update_status: "--",
    can_be_analyzed: false,
    discovery: {
      score: 0,
      your_data: null,
      external_data: null,
    },

    engagement: {
      score: 0,
    },
  },
];

export const mockEngagementScore: Engagement[] = [
  {
    index: 1,
    id: "1",
    name: "--",
    normalized_name: "--",
    penetration_score: null,
    total_engagement_score: null,
    total_calls: null,
    total_calls_responded: null,
    total_emails: null,
    total_emails_responded: null,
    total_meetings: null,
    engagement: {
      score: null,
    },
    discovery: {
      score: null,
    },
  },
  {
    index: 2,
    id: "2",
    name: "--",
    normalized_name: "--",
    penetration_score: null,
    total_engagement_score: null,
    total_calls: null,
    total_calls_responded: null,
    total_emails: null,
    total_emails_responded: null,
    total_meetings: null,
    engagement: {
      score: null,
    },
    discovery: {
      score: null,
    },
  },
  {
    index: 3,
    id: "3",
    name: "--",
    normalized_name: "--",
    penetration_score: null,
    total_engagement_score: null,
    total_calls: null,
    total_calls_responded: null,
    total_emails: null,
    total_emails_responded: null,
    total_meetings: null,
    engagement: {
      score: null,
    },
    discovery: {
      score: null,
    },
  },
];

export const mockPenetrationRate: Penetration[] = [
  {
    index: 1,
    id: "1",
    name: "--",
    normalized_name: "--",
    industry: "--",
    region: "--",
    penetration_score: null,
    total_engagement_score: null,
    region_code: "--",
    engagement: {
      score: null,
    },
    discovery: {
      score: null,
    },
  },
  {
    index: 2,
    id: "2",
    name: "--",
    normalized_name: "--",
    industry: "--",
    region: "--",
    penetration_score: null,
    total_engagement_score: null,
    region_code: "--",
    engagement: {
      score: null,
    },
    discovery: {
      score: null,
    },
  },
  {
    index: 3,
    id: "3",
    name: "--",
    normalized_name: "--",
    industry: "--",
    region: "--",
    penetration_score: null,
    total_engagement_score: null,
    region_code: "--",
    engagement: {
      score: null,
    },
    discovery: {
      score: null,
    },
  },
];

export const mockCompanyMembers: CampaignMember[] = [
  {
    first_name: "--",
    last_name: "--",
    job_title: "--",
    id: "1",
    role: "--",
    committee_probability: 0,
    cluster_probability: 0,
    seniority: "--",
    campaign_id: "--",
    engagement_score: 0,
    data_source: "user_crm",
    highlight_committee: false,
    highlight_cluster: false,
    committee_status: "--",
    cluster_status: "--",
    full_name: "--",
    role_id: undefined,
    is_edited: false,
    is_hidden: false,
    committee: { score: 0 },
    cluster: { score: 0 },
    engagement: { score: 0 },
  },
  {
    first_name: "--",
    last_name: "--",
    job_title: "--",
    id: "2",
    role: "--",
    committee_probability: 0,
    cluster_probability: 0,
    seniority: "--",
    campaign_id: "--",
    engagement_score: 0,
    data_source: "External data",
    highlight_committee: false,
    highlight_cluster: false,
    committee_status: "--",
    cluster_status: "--",
    full_name: "--",
    role_id: undefined,
    is_edited: false,
    is_hidden: false,
    committee: { score: 0 },
    cluster: { score: 0 },
    engagement: { score: 0 },
  },
  {
    first_name: "--",
    last_name: "--",
    job_title: "--",
    id: "3",
    role: "--",
    committee_probability: 0,
    cluster_probability: 0,
    seniority: "--",
    campaign_id: "--",
    engagement_score: 0,
    data_source: "user_crm",
    highlight_committee: false,
    highlight_cluster: false,
    committee_status: "--",
    cluster_status: "--",
    full_name: "--",
    role_id: undefined,
    is_edited: false,
    is_hidden: false,
    committee: { score: 0 },
    cluster: { score: 0 },
    engagement: { score: 0 },
  },
];

export const mockRoleMembers: RoleMembers[] = [
  {
    id: KeyRoles.decision_maker,
    title: "Decision Maker",
    total: 0,
    scraping: null,
    is_active: true,
    status: RoleStatus.active,
    items: [
      {
        id: "b95d5fd0-2397-4863-860e-4cb2f0c8002d",
        name: "--",
        title: "--",
        seniority: "--",
        committee_probability: 0,
        cluster_probability: 0,
        committee_status: "",
        cluster_status: "",
        engagement_score: 0,
        data_source: "user_crm",
        linkedin_updated_at: "",
        warning_tooltip: "",
        is_edited: false,
        is_hidden: false,
        committee: { score: 0 },
        cluster: { score: 0 },
        engagement: { score: 0 },
      },
    ],
  },
  {
    id: KeyRoles.initiator,
    title: "Initiator",
    total: 0,
    scraping: null,
    is_active: true,
    status: RoleStatus.active,
    items: [
      {
        id: "b95d5fd0-2397-4863-860e-4cb2f0c8002d",
        name: "--",
        title: "--",
        seniority: "--",
        committee_probability: 0,
        cluster_probability: 0,
        committee_status: "",
        cluster_status: "",
        engagement_score: 0,
        data_source: "user_crm",
        linkedin_updated_at: "",
        warning_tooltip: "",
        is_edited: false,
        is_hidden: false,
        committee: { score: 0 },
        cluster: { score: 0 },
        engagement: { score: 0 },
      },
    ],
  },
  {
    id: KeyRoles.influencer,
    title: "Influencer",
    total: 0,
    scraping: null,
    is_active: true,
    status: RoleStatus.active,
    items: [
      {
        id: "b95d5fd0-2397-4863-860e-4cb2f0c8002d",
        name: "--",
        title: "--",
        seniority: "--",
        committee_probability: 0,
        cluster_probability: 0,
        committee_status: "",
        cluster_status: "",
        engagement_score: 0,
        data_source: "",
        linkedin_updated_at: "",
        warning_tooltip: "",
        is_edited: false,
        is_hidden: false,
        committee: { score: 0 },
        cluster: { score: 0 },
        engagement: { score: 0 },
      },
    ],
  },
  {
    id: KeyRoles.technical_buyer,
    title: "Technical Buyer",
    total: 0,
    scraping: null,
    is_active: true,
    status: RoleStatus.active,
    items: [
      {
        id: "b95d5fd0-2397-4863-860e-4cb2f0c8002d",
        name: "--",
        title: "--",
        seniority: "--",
        committee_probability: 0,
        cluster_probability: 0,
        committee_status: "",
        cluster_status: "",
        engagement_score: 0,
        data_source: "user_crm",
        linkedin_updated_at: "",
        warning_tooltip: "",
        is_edited: false,
        is_hidden: false,
        committee: { score: 0 },
        cluster: { score: 0 },
        engagement: { score: 0 },
      },
    ],
  },
  {
    id: KeyRoles.champion,
    title: "Champion",
    total: 0,
    scraping: null,
    is_active: true,
    status: RoleStatus.active,
    items: [
      {
        id: "b95d5fd0-2397-4863-860e-4cb2f0c8002d",
        name: "--",
        title: "--",
        seniority: "--",
        committee_probability: 0,
        cluster_probability: 0,
        committee_status: "",
        cluster_status: "",
        engagement_score: 0,
        data_source: "",
        linkedin_updated_at: "",
        warning_tooltip: "",
        is_edited: false,
        is_hidden: false,
        committee: { score: 0 },
        cluster: { score: 0 },
        engagement: { score: 0 },
      },
    ],
  },
  {
    id: KeyRoles.user,
    title: "User",
    total: 0,
    scraping: null,
    is_active: true,
    status: RoleStatus.active,
    items: [
      {
        id: "b95d5fd0-2397-4863-860e-4cb2f0c8002d",
        name: "--",
        title: "--",
        seniority: "--",
        committee_probability: 0,
        cluster_probability: 0,
        committee_status: "",
        cluster_status: "",
        engagement_score: 0,
        data_source: "",
        linkedin_updated_at: "",
        warning_tooltip: "",
        is_edited: false,
        is_hidden: false,
        committee: { score: 0 },
        cluster: { score: 0 },
        engagement: { score: 0 },
      },
    ],
  },
  {
    id: KeyRoles.approver,
    title: "Approver",
    total: 0,
    scraping: null,
    is_active: true,
    status: RoleStatus.active,
    items: [
      {
        id: "b95d5fd0-2397-4863-860e-4cb2f0c8002d",
        name: "--",
        title: "--",
        seniority: "--",
        committee_probability: 0,
        cluster_probability: 0,
        committee_status: "",
        cluster_status: "",
        engagement_score: 0,
        data_source: "user_crm",
        linkedin_updated_at: "",
        warning_tooltip: "",
        is_edited: false,
        is_hidden: false,
        committee: { score: 0 },
        cluster: { score: 0 },
        engagement: { score: 0 },
      },
    ],
  },
  {
    id: KeyRoles.legal_compliance_advisor,
    title: "Legal Compliance Advisor",
    total: 0,
    scraping: null,
    is_active: true,
    status: RoleStatus.active,
    items: [
      {
        id: "b95d5fd0-2397-4863-860e-4cb2f0c8002d",
        name: "--",
        title: "--",
        seniority: "--",
        committee_probability: 0,
        cluster_probability: 0,
        committee_status: "",
        cluster_status: "",
        engagement_score: 0,
        data_source: "",
        linkedin_updated_at: "",
        warning_tooltip: "",
        is_edited: false,
        is_hidden: false,
        committee: { score: 0 },
        cluster: { score: 0 },
        engagement: { score: 0 },
      },
    ],
  },
  {
    id: KeyRoles.blocker,
    title: "Blocker",
    total: 0,
    scraping: null,
    is_active: true,
    status: RoleStatus.active,
    items: [
      {
        id: "b95d5fd0-2397-4863-860e-4cb2f0c8002d",
        name: "--",
        title: "--",
        seniority: "--",
        committee_probability: 0,
        cluster_probability: 0,
        committee_status: "",
        cluster_status: "",
        engagement_score: 0,
        data_source: "user_crm",
        linkedin_updated_at: "",
        warning_tooltip: "",
        is_edited: false,
        is_hidden: false,
        committee: { score: 0 },
        cluster: { score: 0 },
        engagement: { score: 0 },
      },
    ],
  },
  {
    id: KeyRoles.buyer,
    title: "Buyer",
    total: 0,
    scraping: null,
    is_active: true,
    status: RoleStatus.active,
    items: [
      {
        id: "b95d5fd0-2397-4863-860e-4cb2f0c8002d",
        name: "--",
        title: "--",
        seniority: "--",
        committee_probability: 0,
        cluster_probability: 0,
        committee_status: "",
        cluster_status: "",
        engagement_score: 0,
        data_source: "",
        linkedin_updated_at: "",
        warning_tooltip: "",
        is_edited: false,
        is_hidden: false,
        committee: { score: 0 },
        cluster: { score: 0 },
        engagement: { score: 0 },
      },
    ],
  },
  {
    id: KeyRoles.not_involved,
    title: "Not Involved",
    total: 0,
    scraping: null,
    is_active: true,
    status: RoleStatus.active,
    items: [
      {
        id: "b95d5fd0-2397-4863-860e-4cb2f0c8002d",
        name: "--",
        title: "--",
        seniority: "--",
        committee_probability: 0,
        cluster_probability: 0,
        committee_status: "",
        cluster_status: "",
        engagement_score: 0,
        data_source: "user_crm",
        linkedin_updated_at: "",
        warning_tooltip: "",
        is_edited: false,
        is_hidden: false,
        committee: { score: 0 },
        cluster: { score: 0 },
        engagement: { score: 0 },
      },
    ],
  },
];

export const keyRolesItems: Record<KeyRoles, { [key: string]: string }> = {
  [KeyRoles.not_involved]: {
    title: "Not Involved",
    color: "#585858",
    backgroundColor: "#5858580D",
    tooltip: "Not Involved",
    bubbleColor: "#9B9B9B",
  },
  [KeyRoles.decision_maker]: {
    title: "Decision Maker",
    color: "#2E72A2",
    backgroundColor: "#3E9EE226",
    tooltip:
      "Final authority to approve or reject the purchase based on committee input.",
    bubbleColor: "#82AAC7",
  },
  [KeyRoles.initiator]: {
    title: "Initiator",
    color: "#A35E30",
    backgroundColor: "#E2803E26",
    tooltip: "Identifies the problem and kicks off the search for solutions.",
    bubbleColor: "#C89E83",
  },
  [KeyRoles.influencer]: {
    title: "Influencer",
    color: "#A3307A",
    backgroundColor: "#A3307A26",
    tooltip:
      "Provides expert opinions that shape evaluation criteria and committee decisions.",
    bubbleColor: "#C883AF",
  },
  [KeyRoles.technical_buyer]: {
    title: "Technical Buyer",
    color: "#5D8F27",
    backgroundColor: "#6AE23E26",
    tooltip:
      "Evaluates technical specs, feasibility, compliance, and integration.",
    bubbleColor: "#9EBC7D",
  },
  [KeyRoles.champion]: {
    title: "Champion",
    color: "#908D2D",
    backgroundColor: "#E2DD3E26",
    tooltip:
      "Promotes your solution internally, overcomes objections, and rallies support.",
    bubbleColor: "#BCBB81",
  },
  [KeyRoles.user]: {
    title: "User",
    color: "#288C8C",
    backgroundColor: "#28969626",
    tooltip:
      "Directly uses the product/service and benefits from its advantages.",
    bubbleColor: "#7EBABA",
  },
  [KeyRoles.approver]: {
    title: "Approver",
    color: "#B9453A",
    backgroundColor: "#E24C3E26",
    tooltip:
      "Controls budget, reviews financials, and ensures ROI and compliance.",
    bubbleColor: "#E79B66",
  },
  [KeyRoles.legal_compliance_advisor]: {
    title: "Legal Advisor",
    color: "#9A3FC1",
    backgroundColor: "#F3E2FB",
    tooltip: "Ensures legal and regulatory compliance, manages contract risks.",
    bubbleColor: "#C28CDA",
  },
  [KeyRoles.blocker]: {
    title: "Blocker",
    color: "#8D782A",
    backgroundColor: "#A38A3026",
    tooltip:
      "Raises objections (budget, technical, compliance, or preference for competitors).",
    bubbleColor: "#BBAE7F",
  },
  [KeyRoles.buyer]: {
    title: "Buyer",
    color: "#2A8E34",
    backgroundColor: "#30A33B26",
    tooltip:
      "Manages procurement, negotiations, contracts, and budget compliance.",
    bubbleColor: "#7FBB85",
  },
};
